import axios from "axios";
import {
  getUserTypeAPI as getUserTypeFromEnterprise,
  getEnterpriseCompanyListAPI,
} from "../../enterpriseApi";

export const postOnboardingApi = async (formData) => {
    try {
        // const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v2/onboard/submit`, formData, {
            headers: {
                // Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            },
        });


        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postDeleteAccountApi = async (data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user-account/request-delete-account`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            },
        });


        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postRevokeAccountApi = async (data) => {
    const apikey = process.env.REACT_APP_API_KEY;
    const token = localStorage.getItem("objectId")
    try {

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user-account/revoke-deletion-request`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "x-api-key": apikey,
            }
        });

        return response.data;
    } catch (error) {
        console.log("API response", error);

        if (error.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "There is not API response from the server" }
        }
        else {
            return { message: error.message }
        }
    }
}

export const postOnboardingCreateProfessionalCardApi = async (data) => {
    const apikey = process.env.REACT_APP_API_KEY;
    const token = localStorage.getItem("objectId")
    try {

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/professional_experience`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "x-api-key": apikey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API response", error);

        if (error.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "There is not API response from the server" }
        }
        else {
            return { message: error.message }
        }
    }
}

export const postOnboardingCreateStudentCardApi = async (data) => {
    const apikey = process.env.REACT_APP_API_KEY;
    const token = localStorage.getItem("objectId")
    try {

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/educational_info`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "x-api-key": apikey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API response", error);

        if (error.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "There is not API response from the server" }
        }
        else {
            return { message: error.message }
        }
    }
}


export const PatchOnboardingAPI = async (formData) => {
    const apikey = process.env.REACT_APP_API_KEY;
    const token = localStorage.getItem("objectId")
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/personal_profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "x-api-key": apikey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response) {
            return error.response.data;
        } else if (error.request) {
            return { message: "There is not API response from the server" }
        } else {
            return { message: error.message }
        }
    }
}

export const GetEnterPriseCompanyListAPI = async () => {
  return getEnterpriseCompanyListAPI();
};

export const postResumePraisingAPIHelper  = async (formData) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/resume-ocr/`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getUserTypeAPI = getUserTypeFromEnterprise;

export const getUserIdDetailsHelperAPI = async (_userId, customToken) => {
  return getUserTypeFromEnterprise(customToken);
};